module.exports = __webpack_public_path__ + "img/ExitusC_head.da778bac.png";